import * as types from '../mutation-types'
import core from '@/js/core/core'
import EventBus from '@/vue/events/event-bus'

//import vueCookie from 'vue-cookie'

// initial state
const state = {
  statement: {
    showStatement: false,
    showLedger: false,
    showWagerDetail: false,
    selectedStatementDate: {
      from: 0,
      to: 7,
      selected: null, //for wager used
      week: 1, // for api statement
    },
    wagerType: 'openBet', //openBet or statementDetail
    selectedSport: '99',
    selectedWagerPage: 1,
    dateList : [],
    statementList : [],
    wagerList : [],
    last10wagerList: [],
    statementSummary : null,
    isCancelWager: false,
    selectedDateRange: [],

  },
  selectedTab: 'betTab',
  statementDetail: {
    data : {},
    total: null,
  },
  apiWagerDetail: false,
}

// getters
const getters = {
  statementDateList : state => state.statement.dateList,
  selectedStatementDateRange: state => state.statement.selectedDateRange,
  statementList : state => state.statement.statementList,
  statementSummary : state => state.statement.statementSummary,
  wagerList : state => state.statement.wagerList,
  statement : state => state.statement,
  selectedTab: state => state.selectedTab,
  statementDetail: state => state.statementDetail,
  apiWagerDetail: state => state.apiWagerDetail,
}

// actions
const actions = {
  getStatementDetail(context, payload){
    core.$ajax({
      method: 'get',
      url: payload.url,
      data: {token:window.token.arr_2},
    }).done(((res)=> {
      this.commit('STATEMENT_SHOW_LEDGER', true)
      this.commit('STATEMENT_DETAIL', {
        'data' : res.data.DATA,
        'total': res.data.TTL_TRANS,
      })      
      if(payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getStatementList (context, payload) {
    core.$ajax({
      method: 'get',
      url: payload.url,
      data: {
        token: payload.token,
      },
    }).done(((res)=> {
      if(this.getters.account.isApi){
        this.commit('STATEMENT_DATELIST', res.dateList)
        this.commit('STATEMENT_API_DATELIST', res.apiDateList)
        this.commit('STATEMENT_SELECTED_WEEK', res.selectedWeek)
      }else{
        this.commit('STATEMENT_DATELIST', res.dateList)
      }
      this.commit('STATEMENT_LIST', res.data.DATA)
      this.commit('STATEMENT_DATE_RANGE', res.selectedDateRange)     
      if(payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getWagerList (context, payload) {
    var params = {}
    if(this.getters.statement.wagerType == 'statementDetail') {
      //TODO: if sport juz add sport param
      params = {
        wgrTyp: 'statement'
      }
      params.date = this.getters.statement.selectedStatementDate.selected
    } else if (this.getters.statement.wagerType == 'openBet') {
      //TODO : get all uncalculated score
      params = {
        wgrTyp: 'openBet'
      }
    }
    if(this.getters.account.isApi && this.getters.apiWagerDetail){
      params.date = this.getters.statement.selectedStatementDate.selected
      params.isApi = true
    }
    if(payload) {
      state.statement.isCancelWager = false
      
      if(payload.cancelWager) {
        params.cancelWager = true
        state.statement.isCancelWager = true
      } else if (payload.last10Wager) {
        params.last10Wager = true
      } else if (payload.wagerIds) {
        params.wagerIds = payload.wagerIds // array []
        params.wgrTyp = 'openBet'
      }
    }
    params.page = this.getters.statement.selectedWagerPage
    params.sprtId = this.getters.statement.selectedSport
    params.token = payload.token
    if(params.token == undefined){
      params.token = window.token.arr_2;
    }
    EventBus.$emit('WAGER_RELOADING', true)
    core.$ajax({
      method: 'get',
      url: 'sport-wager1',
      data: params,
    }).done(((res)=> {
      state.statement.statementSummary = res.statementSummary
      this.commit('STATEMENT_WAGERLIST', res.wagerList)
      this.commit('STATEMENT_SHOW_WAGERDETAIL', true)
      EventBus.$emit('WAGER_RELOADING', false)
      if(payload) {
        if(payload.callback) {
          return payload.callback(res)
        }
      }
    }).bind(this)).catch((errRes)=> {
      console.error(errRes)
    })
  },
  getLast10Wager (context, payload) {
    var params = {}

    if(payload) {
      if (payload.last10Wager) {
        params.last10Wager = true
      }
      if (payload.wagerIds) {
        params.wagerIds = payload.wagerIds // array []
        params.wgrTyp = 'openBet'
      }

      if (payload.wgrTyp) {
        params.wgrTyp = payload.wgrTyp
      }

      if (payload.novaWager) {
        params.novaWager = payload.novaWager
      }

      if(payload.isCount) {
          params.isCnt =  payload.isCount
          params.sprtId =  '99'
      }
      params.token = payload.token
    }
    params.sprtId = this.getters.statement.selectedSport
    core.$ajax({
      method: 'get',
      url: 'sport-wager1',
      data: params,
    }).done(((res)=> {
      this.commit('PLACED_BET', false)
      if(res.wagerList) {
        this.commit('STATEMENT_LAST10_WAGERLIST', res.wagerList.data)
      }
      if(payload) {
        if(payload.callback) {
          return payload.callback(res)
        }
      }
    }).bind(this)).catch((errRes)=> {
      console.error(errRes)
    })
  },
  getPendingWager (context, payload) {
    var params = {}

    if(payload) {
      if (payload.wagerIds) {
        params.wagerIds = payload.wagerIds // array []
        params.wgrTyp = 'openBet'
        if(payload.isParlay) {
          params.isParlay = payload.isParlay
        }
      }
    }
    params.sprtId = this.getters.statement.selectedSport
    core.$ajax({
      method: 'get',
      url: 'sport-wager1',
      data: params
    }).done(((res)=> {
      if(payload) {
        if(payload.callback) {
          return payload.callback(res)
        }
      }
    }).bind(this)).catch((errRes)=> {
      console.error(errRes)
    })
  },
}

// mutations
const mutations = {
  [types.STATEMENT_SELECTED_WEEK] (state, payload ) {
    state.statement.selectedWeek = payload
  },
  [types.STATEMENT_API_DATELIST] (state, payload ) {
    state.statement.apiDateList = payload
  },
  [types.STATEMENT_DATELIST] (state, payload ) {
    state.statement.dateList = payload
  },

  [types.STATEMENT_LIST] (state, payload ) {
    state.statement.statementList = payload
  },

  [types.STATEMENT_WAGERLIST] (state, payload ) {
    state.statement.wagerList = payload
  },

  [types.STATEMENT_LAST10_WAGERLIST] (state, payload ) {
    state.statement.last10wagerList = payload
  },


  [types.STATEMENT_SELECTED_SPORT] (state, payload ) {
    state.statement.selectedSport = payload
  },

  [types.STATEMENT_SELECTED_DATE] (state, payload ) {
    state.statement.selectedStatementDate = payload
  },

  [types.STATEMENT_SELECTED_WAGER_DATE] (state, payload ) {
    state.statement.selectedStatementDate.selected = payload
  },

  [types.STATEMENT_SELECTED_WAGER_PAGE] (state, payload ) {
    state.statement.selectedWagerPage = payload
  },

  [types.STATEMENT_SHOW_WAGERDETAIL] (state, payload ) {
    state.statement.showWagerDetail = payload
  },

  [types.STATEMENT_WAGER_TYPE] (state, payload ) {
    state.statement.wagerType = payload
  },

  [types.STATEMENT_SHOW_STATEMENT] (state, payload ) {
    state.statement.showStatement = payload
  },
  [types.STATEMENT_SHOW_LEDGER] (state, payload ) {
    state.statement.showLedger = payload
  },

  [types.SELECTED_TAB](state, payload ) {
    state.selectedTab = payload
  },

  [types.SATEMENT_IS_CANCELWAGER](state, payload ) {
    state.statement.isCancelWager = payload
  },
  [types.STATEMENT_DATE_RANGE] (state, payload){
    state.statement.selectedDateRange = payload
  },
  [types.STATEMENT_DETAIL] (state, payload){
    state.statementDetail = payload
  },
  [types.API_WAGER_DETAIL] (state, payload){
    state.apiWagerDetail = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/statement.js